import { useState } from 'react';
import { useFilterAndSorting } from 'src/hooks';
import { IFilter } from 'src/interfaces';
import { lang } from 'src/utils';

export const filters: IFilter[] = [
  {
    placeholder: lang.selectTags,
    labelOverride: lang.ownerOperator.ownerOperatorTags,
    label: lang.locationOwnerTagsName,
    options: [],
    isLoading: false,
    fieldType: 'filterWithSearch',
    badgeOptions: {
      align: 'top',
      color: 'success',
    },
  },
  {
    placeholder: lang.selectZone,
    label: lang.zone,
    options: [],
    isLoading: false,
    fieldType: 'filterWithSearch',
    badgeOptions: {
      align: 'top',
      color: 'success',
    },
  },
  {
    placeholder: lang.selectSubzone,
    label: lang.subZone,
    options: [],
    isLoading: false,
    fieldType: 'filterWithSearch',
    badgeOptions: {
      align: 'top',
      color: 'success',
    },
  },
  {
    labelOverride: lang.storeNumber,
    label: 'store_number',
    isLoading: false,
    options: [],
    fieldType: 'freeSearch',
  },
];

export const useLocationFilters = (activeFilters: {
  [key: string]: string[];
}) => {
  const [isFuzzySearch, setIsFuzzySearch] = useState(
    !('name.list' in activeFilters),
  );

  const {
    onChangeKeyword,
    onRemoveKeyword,
    onChangeFilter,
    onChangeToExactMatch,
    onChangeToFuzzyMatch,
    onReset,
    onChangeParams,
  } = useFilterAndSorting(filters, [], isFuzzySearch, setIsFuzzySearch);

  const onResetFilters = () => {
    Object.keys(activeFilters).forEach((key) => onChangeParams(key, []));
    onReset();
    onChangeParams('store_number.list', []);
  };

  return {
    isFuzzySearch,
    setIsFuzzySearch,
    onChangeToExactMatch,
    onChangeToFuzzyMatch,
    onChangeKeyword,
    onRemoveKeyword,
    onChangeFilter,
    onResetFilters,
  };
};
